/*
 * @Author: Dl
 * @Date: 2020-01-03 10:17:49
 * @Description: 验证策略
 * @LastEditors  : Dl
 * @LastEditTime : 2020-01-03 10:20:25
 */
import { RE_PHONE, RE_ADDR_DETAIL, RE_ADDR_NAME } from './re'

// type ValidateRule =
//   | 'isNotEmpty'
//   | 'isMobile'
//   | 'lenEqual:4'
//   | 'lenEqual:6'
//   | 'lenEqual:11'
//   | 'isValidName'
//   | 'isValidDetail'

export default class Validator {
  // 验证策略
  strategies = {
    // 策略：不能为空
    isNotEmpty (value, errMsg) {
      return value === '' ? errMsg : undefined
    },
    // 策略：手机格式判断
    isMobile (value, errMsg) {
      if (value.includes('****')) return undefined
      return !RE_PHONE.test(value) ? errMsg : undefined
    },
    // 策略：长度等于
    lenEqual (value, length, errMsg) {
      return value.length !== Number(length) ? errMsg : undefined
    },
    // 策略：姓名合法
    isValidName (value, errMsg) {
      return !RE_ADDR_NAME.test(value) ? errMsg : undefined
    },
    // 策略：详细地址合法
    isValidDetail (value, errMsg) {
      return RE_ADDR_DETAIL.test(value) ? errMsg : undefined
    }
  }

  // 策略池
  cache = []
  // 添加策略
  add (data, rule, errMsg) {
    const arr = rule.split(':')
    this.cache.push(() => {
      const item = arr.shift()
      arr.unshift(data)
      arr.push(errMsg)
      return this.strategies[String(item)].apply(null, arr)
    })
    return this
  }

  // 执行
  run () {
    // eslint-disable-next-line space-in-parens
    for (let i = 0, rule; (rule = this.cache[i++]); ) {
      const msg = rule()
      if (msg !== undefined) return msg
    }
  }
}
